<template>
  <footer class="bg-gray-900 text-white">
    <div class="container-custom">
      <!-- Main Footer Content -->
      <div class="py-16">
        <div class="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          <!-- Company Info -->
          <div class="lg:col-span-2">
            <a href="https://www.softentra.com/products/task-manager-pro-wordpress-project-management-plugin-with-time-tracking-team-collaboration" target="_blank" class="flex items-center space-x-3 mb-6">
              <img src="/logo.svg" class="w-10" alt="Logo" />
              <div>
                <h3 class="text-xl font-bold">Task Manager Pro</h3>
                <p class="text-sm text-gray-400">WordPress Plugin</p>
              </div>
            </a>
            <p class="text-gray-400 mb-6 max-w-md">
              Transform your WordPress site into a powerful project management platform. 
              Trusted by thousands of teams worldwide.
            </p>
          </div>
          
          <!-- Product Links -->
          <div>
            <h4 class="text-lg font-semibold mb-6">Product</h4>
            <ul class="space-y-3">
              <li><a href="#features" class="text-gray-400 hover:text-white transition-colors">Features</a></li>
              <li><a href="#screenshots" class="text-gray-400 hover:text-white transition-colors">Screenshots</a></li>
              <li><a href="https://robinhossain.gitbook.io/task-manager-pro/" target="_blank" class="text-gray-400 hover:text-white transition-colors">Documentation</a></li>
            </ul>
          </div>
          
          <!-- Support Links -->
          <div>
            <h4 class="text-lg font-semibold mb-6">Support</h4>
            <ul class="space-y-3">
              <li><a href="#faq" class="text-gray-400 hover:text-white transition-colors">FAQ</a></li>
              <li><a href="#" class="text-gray-400 hover:text-white transition-colors">Contact Support</a></li>
            </ul>
          </div>
        </div>
      </div>
      
      <!-- Bottom Footer -->
      <div class="py-8 border-t border-gray-800">
        <div class="flex flex-col md:flex-row justify-between items-center">
          <div class="text-gray-400 text-sm mb-4 md:mb-0">
            © {{ new Date().getFullYear() }} SoftEntra. All rights reserved. Task Manager Pro is a WordPress plugin.
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>


